import styled from 'styled-components';

export const StyledEmailTemplatesContainer = styled.div`
	padding: 1rem;
	overflow-x: auto;
	width: 100%;
	position: relative;
`;
